import pincodeMaster from "./pincode-master";

export default pincodeMaster;